<div class="container">
  <div>
    <div>
      <h2>Choose Loop Type:</h2>
    </div>
    <div class="flex align-items-baseline">
      <input
        type="radio"
        id="radioPasteTypeBefore"
        name="pasteType"
        [value]="0"
        [(ngModel)]="selectedPasteType"
        [checked]="selectedPasteType === 0"
      />
      <label for="radioPasteTypeBefore">Paste Before</label>
      <input
        type="radio"
        id="radioPasteTypeAfter"
        class="pasteAfterButton"
        name="pasteType"
        [value]="1"
        [(ngModel)]="selectedPasteType"
        [checked]="selectedPasteType === 1"
      />
      <label for="radioPasteTypeAfter">Paste After</label>
    </div>
    <div class="flex align-items-baseline">
      <input
        type="radio"
        id="radioMultiplier"
        name="loopTypeGroup"
        [value]="1"
        [(ngModel)]="selectedLoopType"
        [checked]="selectedLoopType === 1"
      />
      <label for="radioMultiplier">Loop Count: </label>
      <icn-number-input
        [minLength]="1"
        [maxLength]="1000"
        [(value)]="selectedMultiplier"
        [step]="1"
        [useDefaultHtmlInput]="true"
        [allowOnlyButtonUpdates]="true"
        [contentEditable]="selectedLoopType === 1"
      ></icn-number-input>
    </div>

    <div class="flex column align-items-baseline">
      <div>
        <input
          type="radio"
          id="radioUntilDate"
          name="loopTypeGroup"
          [value]="0"
          [(ngModel)]="selectedLoopType"
          [checked]="selectedLoopType === 0"
        />
        <label for="radioUntilDate">Loop Until Date Time</label>
      </div>
      <div>
        <icn-calendar-datepicker
          *ngIf="selectedLoopType === 0"
          (apply)="onDatepickerApply($event)"
          (cancel)="cancelDataPickerClicked($event)"
          (afterInit)="dtAfterInit($event)"
        >
        </icn-calendar-datepicker>
        <evrideo-calendar-icon
          *ngIf="targetEndTimeDatePicker && selectedLoopType === 0"
          (click)="openDatePicker()"
        ></evrideo-calendar-icon>
        <label
          class="selected-start-time"
          *ngIf="
            targetEndTimeDatePicker && selectedLoopType === 0 && targetEndTime
          "
          (click)="openDatePicker()"
          >{{ targetEndTime.format("DD/MM/YYYY HH:mm") }}</label
        >
      </div>
    </div>
    <div class="flex column align-items-baseline">
      <div>
        <input
          type="radio"
          id="radioUntilNextItem"
          name="loopTypeGroup"
          [value]="2"
          [(ngModel)]="selectedLoopType"
          [checked]="selectedLoopType === 2"
        />
        <label for="radioUntilNextItem">Loop Until Next Item </label>
      </div>
      <div *ngIf="selectedLoopType === 2">
        <label>
          <input
            type="checkbox"
            id="checkboxUntilNextItem"
            [(ngModel)]="untilNextItemWithPartial"
          />
          Partially schedule without gap
        </label>
      </div>
    </div>
    <div class="flex controls space-between align-items-center">
      <span id="error-messsge" [class.hidden]="!errorMessage">{{
        errorMessage
      }}</span>
      <ichannel-button
        [label]="'APPLY'"
        [theme]="'DARK'"
        [callback]="applyClicked.bind(this)"
        class="flex"
      ></ichannel-button>
    </div>
  </div>
</div>
